/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.IndustryUseCaseRpc
 */

export const asyncBulkGenerateIndustryUseCaseRpc = {
  serviceName: 'com.hubspot.academy.gen.ai.skills.rpc.IndustryUseCaseRpc',
  rpcName: 'asyncBulkGenerateIndustryUseCase',
  auth: 'app',
  fingerprint: 'vgCb7UpjL5u8zTTm1KdxAyzqsfS-LNDe',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const asyncBulkGetIndustryUseCaseRpc = {
  serviceName: 'com.hubspot.academy.gen.ai.skills.rpc.IndustryUseCaseRpc',
  rpcName: 'asyncBulkGetIndustryUseCase',
  auth: 'app',
  fingerprint: 'AC6TlXYogRWIinEDmg_iVCzqsfS-LNDe',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};